import {useContext, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {performSignOut} from "../../utils/signOutRouting.js";

export default function SignOut() {
    const {context, setCurrentIdentity} = useContext(GlobalContext);
    const navigate = useNavigate();
    const performedRef = useRef(false);

    useEffect(() => {
        if (performedRef.current) return;
        performedRef.current = true;

        performSignOut({
            currentIdentity: context.currentIdentity,
            setCurrentIdentity,
            navigate,
        });
    }, [context.currentIdentity, navigate, setCurrentIdentity]);

    return null;
}
